var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlayBictorys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 41,
    viewBox: "0 0 135 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GooglePlay_Bictorys",
    clipPath: "url(#clip0_12_2140)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.998 40.5002H5.00184C2.24512 40.5002 0 38.2459 0 35.5002V5.50024C0 2.74463 2.24512 0.500244 5.00184 0.500244H129.998C132.752 0.500244 135 2.74463 135 5.50024V35.5002C135 38.2459 132.752 40.5002 129.998 40.5002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.998 1.30074C132.31 1.30074 134.203 3.18852 134.203 5.50024V35.5002C134.203 37.812 132.323 39.6997 129.998 39.6997H5.00184C2.68967 39.6997 0.797215 37.812 0.797215 35.5002V5.50024C0.797215 3.18852 2.67725 1.30074 5.00184 1.30074H129.998ZM129.998 0.500244H5.00184C2.24512 0.500244 0 2.75461 0 5.50024V35.5002C0 38.2559 2.24512 40.5002 5.00184 40.5002H129.998C132.752 40.5002 135 38.2559 135 35.5002V5.50024C135 2.75461 132.752 0.500244 129.998 0.500244Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M71.1184 13.7322C70.2169 13.7322 69.4569 13.4155 68.8559 12.7921C68.2599 12.1861 67.9271 11.3507 67.942 10.4978C67.942 9.58756 68.2499 8.81699 68.8559 8.20602C69.4545 7.58258 70.2144 7.26587 71.1159 7.26587C72.0075 7.26587 72.7675 7.58258 73.3784 8.20602C73.9844 8.83694 74.2923 9.60752 74.2923 10.4978C74.2824 11.4105 73.9745 12.1811 73.3784 12.7896C72.7799 13.418 72.0199 13.7322 71.1184 13.7322ZM44.2939 13.7322C43.4123 13.7322 42.6473 13.4205 42.0215 12.8045C41.4006 12.1911 41.0852 11.4155 41.0852 10.5003C41.0852 9.58507 41.4006 8.80951 42.0215 8.19604C42.6349 7.58008 43.3998 7.26836 44.2939 7.26836C44.731 7.26836 45.1557 7.35565 45.563 7.5327C45.9628 7.70477 46.2882 7.93919 46.5291 8.22597L46.5887 8.29829L45.9157 8.96163L45.8461 8.87934C45.4661 8.42547 44.957 8.20353 44.284 8.20353C43.683 8.20353 43.1589 8.41799 42.7268 8.84193C42.2922 9.26836 42.0712 9.82697 42.0712 10.5028C42.0712 11.1786 42.2922 11.7372 42.7268 12.1636C43.1589 12.5876 43.683 12.802 44.284 12.802C44.9247 12.802 45.4636 12.5876 45.8834 12.1636C46.1317 11.9142 46.2857 11.5651 46.3403 11.1237H44.1822V10.1911H47.2667L47.2791 10.2758C47.3015 10.433 47.3238 10.595 47.3238 10.7447C47.3238 11.605 47.0655 12.3008 46.5539 12.8145C45.9728 13.423 45.2128 13.7322 44.2939 13.7322ZM79.9597 13.6H79.0086L76.0954 8.91924L76.1202 9.76213V13.5975H75.169V7.40053H76.2543L76.2841 7.44791L79.0235 11.8569L78.9986 11.0165V7.40053H79.9597V13.6ZM63.9708 13.6H63.0072V8.3332H61.3358V7.40053H65.6398V8.3332H63.9684V13.6H63.9708ZM60.551 13.6H59.5899V7.40053H60.551V13.6ZM55.1494 13.6H54.1883V8.3332H52.5168V7.40053H56.8208V8.3332H55.1494V13.6ZM51.9084 13.5901H48.2228V7.40053H51.9084V8.3332H49.1864V10.0339H51.6426V10.9566H49.1864V12.6574H51.9084V13.5901ZM69.5612 12.1512C69.9909 12.5826 70.5124 12.7995 71.1184 12.7995C71.7418 12.7995 72.2509 12.5876 72.6756 12.1512C73.0978 11.7272 73.3114 11.1711 73.3114 10.5003C73.3114 9.82946 73.0978 9.27086 72.6781 8.84941C72.2484 8.41799 71.7244 8.20103 71.1209 8.20103C70.4975 8.20103 69.9884 8.413 69.5662 8.84941C69.144 9.27335 68.9304 9.82946 68.9304 10.5003C68.9304 11.1711 69.1415 11.7297 69.5612 12.1512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8526 22.2559C65.5056 22.2559 63.6032 24.0439 63.6032 26.5103C63.6032 28.9542 65.518 30.7646 67.8526 30.7646C70.1995 30.7646 72.1019 28.9641 72.1019 26.5103C72.1019 24.0439 70.1995 22.2559 67.8526 22.2559ZM67.8526 29.0788C66.5686 29.0788 65.4634 28.0115 65.4634 26.5003C65.4634 24.9666 66.5711 23.9217 67.8526 23.9217C69.1366 23.9217 70.2417 24.9666 70.2417 26.5003C70.2442 28.0215 69.1366 29.0788 67.8526 29.0788ZM58.5815 22.2559C56.2346 22.2559 54.3322 24.0439 54.3322 26.5103C54.3322 28.9542 56.247 30.7646 58.5815 30.7646C60.9285 30.7646 62.8309 28.9641 62.8309 26.5103C62.8309 24.0439 60.926 22.2559 58.5815 22.2559ZM58.5815 29.0788C57.2975 29.0788 56.1924 28.0115 56.1924 26.5003C56.1924 24.9666 57.3 23.9217 58.5815 23.9217C59.8655 23.9217 60.9707 24.9666 60.9707 26.5003C60.9707 28.0215 59.8655 29.0788 58.5815 29.0788ZM47.5496 23.5552V25.3557H51.8536C51.722 26.3656 51.3892 27.1113 50.8801 27.6225C50.2492 28.2559 49.2757 28.9442 47.5596 28.9442C44.9146 28.9442 42.8458 26.7995 42.8458 24.1437C42.8458 21.4878 44.9146 19.3432 47.5596 19.3432C48.9876 19.3432 50.0282 19.9093 50.8006 20.6325L52.0722 19.3557C50.9993 18.3232 49.5712 17.5327 47.5695 17.5327C43.9411 17.5327 40.8962 20.5003 40.8962 24.1337C40.8962 27.7771 43.9386 30.7347 47.5695 30.7347C49.529 30.7347 50.9993 30.0913 52.1616 28.8793C53.3462 27.6898 53.7212 26.0115 53.7212 24.6574C53.7212 24.236 53.6889 23.8569 53.6219 23.5352H47.5472C47.5496 23.5327 47.5496 23.5552 47.5496 23.5552ZM92.673 24.9567C92.3179 24.0015 91.245 22.2459 89.0446 22.2459C86.8641 22.2459 85.0511 23.9691 85.0511 26.5003C85.0511 28.8893 86.8442 30.7547 89.2557 30.7547C91.1929 30.7547 92.3204 29.5651 92.7848 28.8669L91.3468 27.8993C90.87 28.61 90.2069 29.0764 89.2656 29.0764C88.3144 29.0764 87.6488 28.6424 87.2068 27.7871L92.8717 25.4305C92.8717 25.433 92.673 24.9567 92.673 24.9567ZM86.8963 26.3781C86.8516 24.7347 88.1679 23.8993 89.1092 23.8993C89.8517 23.8993 90.4701 24.2659 90.6813 24.7995L86.8963 26.3781ZM82.2943 30.5003H84.1545V18.0015H82.2943V30.5003ZM79.2396 23.201H79.1725C78.7528 22.6998 77.9556 22.2459 76.9373 22.2459C74.8239 22.2459 72.8768 24.1138 72.8768 26.5128C72.8768 28.9018 74.8139 30.7472 76.9373 30.7472C77.9432 30.7472 78.7528 30.2908 79.1725 29.7796H79.2396V30.3906C79.2396 32.014 78.3753 32.8893 76.9821 32.8893C75.8421 32.8893 75.1343 32.0664 74.8462 31.3781L73.2294 32.0564C73.6939 33.1786 74.9331 34.5676 76.9796 34.5676C79.1601 34.5676 81.0079 33.2784 81.0079 30.1337V22.5003H79.2495V23.201C79.252 23.201 79.2396 23.201 79.2396 23.201ZM77.1037 29.0788C75.8198 29.0788 74.7469 28.0015 74.7469 26.5128C74.7469 25.0115 75.8198 23.9242 77.1037 23.9242C78.3753 23.9242 79.3613 25.024 79.3613 26.5128C79.3737 28.0015 78.3778 29.0788 77.1037 29.0788ZM101.383 18.0015H96.9348V30.5003H98.795V25.7671H101.385C103.444 25.7671 105.468 24.2684 105.468 21.8893C105.468 19.5103 103.452 18.0015 101.383 18.0015ZM101.437 24.0215H98.7925V19.7322H101.437C102.831 19.7322 103.618 20.8868 103.618 21.8769C103.618 22.8569 102.821 24.0215 101.437 24.0215ZM112.924 22.2335C111.573 22.2335 110.18 22.8345 109.603 24.1437L111.252 24.832C111.608 24.1437 112.258 23.9093 112.946 23.9093C113.91 23.9093 114.883 24.4878 114.906 25.5202V25.6524C114.573 25.4629 113.843 25.1736 112.969 25.1736C111.188 25.1736 109.382 26.1512 109.382 27.9841C109.382 29.6624 110.843 30.7397 112.469 30.7397C113.719 30.7397 114.406 30.1736 114.836 29.5178H114.903V30.4853H116.696V25.6973C116.696 23.4679 115.047 22.2335 112.924 22.2335ZM112.69 29.0788C112.082 29.0788 111.23 28.7796 111.23 28.0115C111.23 27.0439 112.293 26.6774 113.199 26.6774C114.019 26.6774 114.407 26.8544 114.893 27.0988C114.759 28.221 113.815 29.0689 112.69 29.0788ZM123.238 22.5003L121.102 27.9217H121.035L118.822 22.5003H116.82L120.141 30.0788L118.249 34.2908H120.186L125.294 22.5003H123.238ZM106.494 30.5003H108.354V18.0015H106.494V30.5003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3913 8.03388C10.1032 8.34561 9.93677 8.82191 9.93677 9.44536V31.5576C9.93677 32.181 10.1032 32.6573 10.4012 32.9566L10.4782 33.0239L22.8164 20.6349V20.3581L10.4682 7.96655L10.3913 8.03388Z",
    fill: "url(#paint0_linear_12_2140)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9214 24.777L22.8062 20.6448V20.3556L26.9214 16.2234L27.0108 16.2783L31.8786 19.0563C33.2718 19.8443 33.2718 21.1461 31.8786 21.9441L27.0108 24.7221L26.9214 24.777Z",
    fill: "url(#paint1_linear_12_2140)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0109 24.7222L22.8063 20.5002L10.3911 32.9666C10.8456 33.4554 11.608 33.5102 12.4599 33.0339L27.0109 24.7222Z",
    fill: "url(#paint2_linear_12_2140)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0109 16.2782L12.4599 7.97894C11.608 7.49016 10.8431 7.55749 10.3911 8.04627L22.8063 20.5001L27.0109 16.2782Z",
    fill: "url(#paint3_linear_12_2140)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9214 24.6326L12.4697 32.8769C11.6625 33.3433 10.9423 33.3108 10.4779 32.8869L10.4009 32.9642L10.4779 33.0315C10.9423 33.453 11.6625 33.4879 12.4697 33.0216L27.0208 24.7223L26.9214 24.6326Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8787 21.7995L26.9092 24.6324L26.9986 24.7222L31.8663 21.9441C32.5642 21.5451 32.9069 21.0214 32.9069 20.5002C32.8647 20.979 32.5095 21.4329 31.8787 21.7995Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.46 8.12378L31.8788 19.2011C32.5096 19.5577 32.8648 20.024 32.9194 20.5003C32.9194 19.9791 32.5767 19.4555 31.8788 19.0564L12.46 7.97914C11.0668 7.17865 9.93677 7.84697 9.93677 9.44548V9.59012C9.93677 7.98912 11.0668 7.33326 12.46 8.12378Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_2140",
    x1: 21.7097,
    y1: 9.20679,
    x2: 1.93526,
    y2: 14.4541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12_2140",
    x1: 33.6955,
    y1: 20.5002,
    x2: 9.59777,
    y2: 20.5002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12_2140",
    x1: 24.7246,
    y1: 22.7976,
    x2: 8.76185,
    y2: 49.5541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12_2140",
    x1: 7.26483,
    y1: 0.678927,
    x2: 14.3865,
    y2: 12.6288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_2140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 40,
    fill: "white",
    transform: "translate(0 0.500244)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayBictorys);
export default __webpack_public_path__ + "static/media/GooglePlay_Bictorys.84bcf6be072756b29ce0b8aee3a76cb1.svg";
export { ForwardRef as ReactComponent };